export const InstructionsArr = ({
  qpInstruction,
  scheduleInstruction,
}: {
  qpInstruction: string | undefined;
  scheduleInstruction: string ;
}) => {
  const qpInstructionsAvailable = qpInstruction && qpInstruction.length > 0;
  const scheduleInstructionsAvailable =
    scheduleInstruction && scheduleInstruction.length > 0;

  if (qpInstructionsAvailable && scheduleInstructionsAvailable) {
    return ["schedule", "qp"];
  }
  if (qpInstructionsAvailable && !scheduleInstructionsAvailable) {
    return ["qp"];
  }
  if (!qpInstructionsAvailable && scheduleInstructionsAvailable) {
    return ["schedule"];
  }
  if (!qpInstructionsAvailable && !scheduleInstructionsAvailable) {
    return [""];
  }
};
